import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.jpg'


const _withScopeId = n => (_pushScopeId("data-v-5dca224c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "screen-width-min" }, "Asiainfo Vanlink ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "screen-tit" }, " 亚信万联", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))
const _hoisted_6 = { class: "link-router" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-item screen-tit" }, " | ", -1))
const _hoisted_8 = { class: "menu-link screen-tit" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "dm" }
const _hoisted_11 = { class: "dm-tit" }
const _hoisted_12 = { class: "dm-label" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" 产品体验 "),
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-xiangxiajiantou" })
], -1))

import { ref, computed } from "vue";
import { useRoute } from "vue-router";



export default /*#__PURE__*/_defineComponent({
  __name: 'Menu',
  setup(__props) {

const skiplList = [
  {
    name: "物联设备管理云平台",
    ele: "VanDM",
    icon: "iconfont icon-wulianwang",
    connected: "https://cloudtest.aivanlink.com/",
  },
  {
    name: "能耗管理系统",
    ele: "VanEMS",
    icon: "iconfont icon-nenghaochengben",
    connected: "https://cloudtest.aivanlink.com/iotx/ems",
  },
];

// const skiplVisible = ref(false);

// const activeIndex = ref("/home");
const router = useRoute();
const defaultActiveMenu = computed(() => {
  const { meta, path } = router;
  return meta?.activeMenu || path;
});

const bgColor = ref("linear-gradient(to right, #13557e, #13557e)");
const fzColor = ref("#fff"); // 初始背景色
// const items = ref(
//   Array.from({ length: 100 }, (_, index) => ({ id: index + 1 }))
// );
// const { meta, path } = router;
// const handleScroll = () => {
//   if (path == "/home") {
//     const scrollPosition = window.scrollY || window.pageYOffset;
//     // 根据滚动条位置设置背景色
//     if (scrollPosition > 500) {
//       bgColor.value = "#fff";
//       fzColor.value = "#000";
//     } else {
//       bgColor.value = "linear-gradient(to right, #13557e, #13557e)";
//       fzColor.value = "#fff";
//     }
//   }
// };

// const targetElement = ref(null);

const onRouterLine = (val) => {
  // console.log(val);
  window.open(val, "_blank");
};
// const goAnchor = (target) => {
//   EventBus.emit("scroll-to-target", target);
//   activeLink.value = target;
// };

// const activeLink = ref(null);

// onMounted(() => {
//   // 监听滚动事件
//   window.addEventListener("scroll", handleScroll);
//   // goAnchor("home");
// });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    "default-active": defaultActiveMenu.value,
    mode: "horizontal",
    style: _normalizeStyle({ background: bgColor.value }),
    router: "",
    ellipsis: false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_router_link, {
        type: "div",
        class: "logo",
        to: "/home"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("h3", {
            style: _normalizeStyle({ color:fzColor.value })
          }, _hoisted_4, 4)
        ]),
        _: 1
      }),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_menu_item, {
          style: _normalizeStyle({ color:fzColor.value }),
          index: "/home"
        }, {
          default: _withCtx(() => [
            _createTextVNode("首页")
          ]),
          _: 1
        }, 8, ["style"]),
        _createVNode(_component_el_menu_item, {
          style: _normalizeStyle({ color:fzColor.value }),
          index: "/products"
        }, {
          default: _withCtx(() => [
            _createTextVNode("产品案列")
          ]),
          _: 1
        }, 8, ["style"]),
        _createVNode(_component_el_menu_item, {
          style: _normalizeStyle({ color:fzColor.value }),
          index: "/profile"
        }, {
          default: _withCtx(() => [
            _createTextVNode("关于我们")
          ]),
          _: 1
        }, 8, ["style"]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_popover, {
            placement: "top-start",
            width: 260,
            trigger: "hover",
            "popper-class": "popover"
          }, {
            reference: _withCtx(() => [
              _hoisted_13
            ]),
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(skiplList, (item) => {
                return _createElementVNode("div", {
                  class: "van-dm",
                  key: item.name,
                  onClick: ($event: any) => (onRouterLine(item.connected))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(item.icon)
                  }, null, 2),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(item.ele), 1),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(item.name), 1)
                  ])
                ], 8, _hoisted_9)
              }), 64))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["default-active", "style"]))
}
}

})